/* @flow */
import * as React from "react";
import SizeMe from "react-sizeme";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import Switch from "./internal/Switch";
import Theme from "./Theme";

type PropsWithoutSize = {
  locked: boolean,
  disabled?: boolean,
  lockedLabel?: string,
  unlockedLabel?: string,
  onChange: (newLockedValue: boolean) => void,
  colors: ColorSet,
};

type Props = PropsWithoutSize & {
  size: {
    width: number,
    height: number,
  },
};

const styles = {
  wrapper: {
    height: "1.6em",
    width: "100%",
  },
};

class SlideToUnlock extends React.Component<Props> {
  static defaultProps = {
    lockedLabel: "Locked",
    unlockedLabel: "Unlocked",
  };

  render() {
    const {
      locked,
      lockedLabel,
      unlockedLabel,
      disabled,
      onChange,
      size,
      colors,
    } = this.props;

    return (
      <div style={styles.wrapper}>
        <Switch
          aria-label={lockedLabel}
          checked={locked}
          disabled={disabled}
          width={size.width}
          height={size.height}
          changeOnTap={false}
          offColor={colors.RED}
          offBackgroundText={unlockedLabel}
          onColor={colors.PRIMARY}
          onBackgroundText={lockedLabel}
          onChange={onChange}
        />
      </div>
    );
  }
}

const SizedSlideToUnlock = SizeMe({
  monitorHeight: true,
  monitorWidth: true,
  refreshRate: Theme.RESPONSIVE_REFRESH_RATE,
})(SlideToUnlock);

class SlideToUnlockWrapper extends React.Component<PropsWithoutSize> {
  render() {
    return (
      <SizedSlideToUnlock
        style={styles.wrapper} // provide an unused style prop so SizeMe knows how to style the placeholder
        {...this.props}
      />
    );
  }
}

export default withColorsProvider(SlideToUnlockWrapper);



// WEBPACK FOOTER //
// ../nx-components/src/SlideToUnlock.jsx